<template>
    <div class="icon-Trash-Can"></div>
</template>